import React, { useRef } from "react";
import styled from "styled-components";
import { SpaceProps, space } from "styled-system";
import { typeSize } from "../theme";
import { Switch } from "./Switch";

export type FormToggleProps = {
  value: boolean;
  onChange: (val: boolean) => void;
  helpText?: string;
  label: string;
  disabled?: boolean;
} & SpaceProps;

const Container = styled.div<SpaceProps>`
  border: 1px solid ${(props) => props.theme.colors.border};
  background-color: ${(props) => props.theme.colors.surface};
  display: flex;
  justify-content: space-between;
  gap: 16px;
  border-radius: ${(props) => props.theme.borderRadius.md}px;
  padding: 16px 18px;
  align-items: center;
  ${space};
`;

const Label = styled.label<{ disabled?: boolean }>`
  font-weight: 500;
  color: ${(p) => p.theme.colors.text};
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
`;

const Help = styled.div`
  font-size: ${typeSize("small")};
  color: ${(p) => p.theme.colors.textMuted};
`;

let idCounter = 0;

export function FormToggle({
  value,
  onChange,
  label,
  helpText,
  disabled,
  ...rest
}: FormToggleProps) {
  const id = useRef(`form-toggle-${++idCounter}`).current;

  return (
    <Container {...rest}>
      <div>
        <Label htmlFor={id} disabled={disabled}>
          {label}
        </Label>
        {helpText && <Help id={`${id}-help`}>{helpText}</Help>}
      </div>
      <Switch
        id={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        aria-describedby={helpText ? `${id}-help` : undefined}
      />
    </Container>
  );
}
